import { render } from "./TabInfo.vue?vue&type=template&id=172b3141&scoped=true&ts=true"
import script from "./TabInfo.vue?vue&type=script&lang=ts"
export * from "./TabInfo.vue?vue&type=script&lang=ts"

import "./TabInfo.vue?vue&type=style&index=0&id=172b3141&lang=scss&scoped=true"

import exportComponent from "G:\\Runze\\rzhy_main_web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-172b3141"]])

export default __exports__